import { useMainStore } from "@/store/main";
import { LngLatTuple } from "@/types/common";
import { APPCallJS } from "@/utils/interactive";
import {
  GraphicInfo,
  lngLatListToLatLngList,
  lngLatToLatLng,
  toNotClosedPath,
} from "@tuliu/base-map";
import { LatLngTuple } from "@tuliu/leaflet";
import _get from "lodash/get";
import _toNumber from "lodash/toNumber";

type SoilInfo = {
  id: number;
  soilArea: number;
  coordinates: string;
  quequanInfo: {
    areaQuequan?: number;
  };
};

const soilInfoToGraphicInfo = (soilInfo: SoilInfo): GraphicInfo => {
  const quequanAreaMu = _toNumber(_get(soilInfo, "quequanInfo.areaQuequan", 0));
  const coordinates = _get(soilInfo, "coordinates", "").trim();
  const formatPath =
    coordinates !== ""
      ? toNotClosedPath(
          lngLatListToLatLngList(JSON.parse(soilInfo.coordinates))
        )
      : [];

  return {
    id: +soilInfo.id,
    path: formatPath,
    isClosed: coordinates !== "",
    extInfo: {
      id: +soilInfo.id,
      quequanAreaMu: quequanAreaMu,
    },
    // 后台存的亩
    area: +soilInfo.soilArea * 666.6,
    // 后台没有存周长
    length: 0,
  };
};

/**
 * 设置中心点
 * @param callback
 */
export const useOnSetLocation = (callback: (info: LatLngTuple) => void) => {
  APPCallJS.on<{ location: LngLatTuple }>("set_location", (data) => {
    const { location } = data;

    const mainStore = useMainStore();
    if (Array.isArray(location) && location[0] && location[1]) {
      const location = lngLatToLatLng(data.location);
      mainStore.userLocation = location;
      mainStore.getUserLocationName(location);
      callback(location);
    } else {
      console.log("set_location 数据错误!");
    }
  });
};

/**
 * 编辑单个地块
 */
export const useOnEditorSingleLand = (
  callback: (info: GraphicInfo[]) => void
) => {
  APPCallJS.on<SoilInfo>("set_land_data_save", (data) => {
    callback([soilInfoToGraphicInfo(data)]);
  });
};

/**
 * 编辑认领的土地
 */
export const useOnEditorClaim = (
  callback: (info: {
    hasPathCount: number;
    notHasPathCount: number;
    list: GraphicInfo[];
  }) => void
) => {
  APPCallJS.on<{
    soilCountOfGeo: number;
    soilCountOfNoGeo: number;
    soilRecordList: SoilInfo[];
  }>("set_land_data_renling", (data) => {
    callback({
      hasPathCount: data.soilCountOfGeo,
      notHasPathCount: data.soilCountOfNoGeo,
      list: data.soilRecordList.map((item) => soilInfoToGraphicInfo(item)),
    });
  });
};

/**
 * 设置快速找地按钮是否可见
 */
export const useOnSetQuickSearchVisible = (
  callback: (info: boolean) => void
) => {
  APPCallJS.on<boolean>("set_quick_search_visible", (data) => {
    callback(data);
  });
};

/**
 * 刷新页面
 */
export const useOnRefresh = (callback: () => void) => {
  APPCallJS.on<boolean>("set_refresh", () => {
    callback();
  });
};
